import type { WorldView } from "../render/world-view.js";
import { AnchoredOverlay } from "./anchored-overlay.js";

export interface DamageSpawn {
  amount: number;
  crit: boolean;
  anchorId: string;
  variant: "incoming" | "outgoing" | "self" | "heal";
}

export class DamageNumberManager {
  private readonly overlay: AnchoredOverlay<DamageSpawn>;

  constructor(layer: HTMLElement, worldView: WorldView) {
    this.overlay = new AnchoredOverlay({
      layer,
      worldView,
      durationMs: 1100,
      fadeBeforeMs: 400,
      yOffset: -24,
      riseProgressPx: 28,
      createNode: (spawn) => {
        const el = document.createElement("div");
        el.className = `dmg-number dmg-${spawn.variant}${spawn.crit ? " dmg-crit" : ""}`;
        if (spawn.variant === "heal") {
          el.textContent = `+${spawn.amount}`;
        } else {
          el.textContent = spawn.crit ? `${spawn.amount}!` : String(spawn.amount);
        }
        return el;
      },
    });
  }

  spawn(spawn: DamageSpawn, now = performance.now()): void {
    this.overlay.spawn(spawn.anchorId, spawn, now);
  }

  destroy(): void {
    this.overlay.destroy();
  }
}
